import { FC, useEffect, useState } from "react";
import fundService, { TransferEstimationDates, TransferSimulationManagerInfo } from "../../../../services/FundService";
import { TPortfolioOrderDataRows } from "../types/TPorfolioOrders";
import { MainButton } from "@/screen/PortfolioModel/SummaryPortfolioModel/Styles/SummaryPortfolioModelStyles";
import { TransferTimeLineProgress } from "@/screen/PurchaseTransferScreen/components/TransferTimeLineProgress";

const BASE_CLASS = "simulationModal";

type TSimulationModal = {
    row: TPortfolioOrderDataRows;
    showModal: () => void;
};

export const SimulationModal: FC<TSimulationModal> = ({ row, showModal }) => {
    const [transferDates, setTransferDates] = useState<TransferEstimationDates>({
        compraLiquidacion: "",
        compraValor: "",
        finalProceso: "",
        ventaLiquidacion: "",
        ventaValor: "",
    });

    const [originInfo, setOriginInfo] = useState<TransferSimulationManagerInfo[]>([]);
    const [targetInfo, setTargetInfo] = useState<TransferSimulationManagerInfo[]>([]);

    const [loading, setLoading] = useState(false);

    const fundOrigenIsin = row.fund.isinOrig;
    const fundDestinoIsin = row.fund.isinDesty;

    useEffect(() => {
        setLoading(true);

        const loadData = async () => {
            try {
                const [origin, target] = await Promise.all([
                    fundService.GetTransferSimulationManagerInfo([fundOrigenIsin], []),
                    fundService.GetTransferSimulationManagerInfo([fundDestinoIsin], []),
                ]);

                setOriginInfo(origin);
                setTargetInfo(target);

                const dates = await fundService.getTransferEstimationDates(
                    fundOrigenIsin,
                    fundDestinoIsin,
                    true,
                    row.date.replace(/\//g, '-') || ''
                );

                if (dates) {
                    setTransferDates({
                        ventaValor: dates.ventaValor,
                        ventaLiquidacion: dates.ventaLiquidacion,
                        compraValor: dates.compraValor,
                        compraLiquidacion: dates.compraLiquidacion,
                        finalProceso: dates.finalProceso
                    });
                }
            } finally {
                setLoading(false);
            }
        };

        loadData();
    }, [fundOrigenIsin, fundDestinoIsin]);

    return (
        <div className={BASE_CLASS}>
            <div className={`${BASE_CLASS}__wrapper`}>
                    <TransferTimeLineProgress
                        isLoadingProps={loading}
                        transferEstimationDates={transferDates}
                        simulationManagerInfoTarget={targetInfo}
                        simulationManagerInfoOrigin={originInfo}
                        orderDate={row.date}
                    />
                    <MainButton onClick={()=> showModal()}>Cerrar</MainButton>
            </div>
        </div>
    );
};